export default __webpack_public_path__ + "static/media/b-transparent.086254d1.svg";